import useKeyupHandler from './useKeyupHandler';

const useHandlerOnEnter = (handler) =>
  useKeyupHandler(['Enter', 'NumpadEnter'], handler);

export default useHandlerOnEnter;
